(() => {
  const formatMoney = (cents) =>
    new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    }).format(cents / 100);

  const updatePaymentTotals = (container) => {
    const productRoot = container.closest('[data-product-id], product-information') || document;
    const quantityInput =
      productRoot.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const paypalCents = Number.parseInt(container.dataset.paypalCents || '0', 10);
    const codCents = Number.parseInt(container.dataset.codCents || '0', 10);

    container.querySelector('[data-re-payment-total="paypal"]')?.replaceChildren(
      document.createTextNode(formatMoney(paypalCents * quantity))
    );
    container.querySelector('[data-re-payment-total="cod"]')?.replaceChildren(
      document.createTextNode(formatMoney(codCents * quantity))
    );
  };

  const refreshAll = () => {
    document.querySelectorAll('[data-re-payment-choice]').forEach(updatePaymentTotals);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches('input[name="quantity"]')) refreshAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="quantity"]')) refreshAll();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('button[name="plus"], button[name="minus"], .quantity-selector button')) {
      requestAnimationFrame(refreshAll);
    }
  });
  document.addEventListener('shopify:section:load', refreshAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  } else {
    refreshAll();
  }
})();
